import { useState } from "react";
import { useTranslation } from "react-i18next";
import CookieManageModal from "./CookieManageModal";
import { type ConsentPreferences } from "@/hooks/useCookieConsent";
import CustomButton from "@/shared/customFields/CustomButton";

interface Props {
  current: ConsentPreferences | null;
  onAccept: () => void;
  onReject: () => void;
  onSave: (prefs: ConsentPreferences) => void;
}

export default function CookieConsentBanner({
  current,
  onAccept,
  onReject,
  onSave,
}: Props) {
  const { t } = useTranslation("cookieConsent");
  const [manageOpen, setManageOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-2 left-1/2 -translate-x-1/2 w-[calc(100%-1rem)] sm:w-fit max-w-2xl z-50 bg-card shadow-2xl rounded-2xl">
        <div className="px-4 py-4 flex flex-col gap-4">
          <div>
            <p className="text-sm font-semibold text-foreground mb-1">
              {t("title")}
            </p>
            <p className="text-xs text-foreground/70 leading-relaxed">
              {t("description")}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2">
            <CustomButton text={t("reject")} theme="light" onClick={onReject} />
            <CustomButton
              text={t("manage.button")}
              theme="light"
              onClick={() => setManageOpen(true)}
            />
            <CustomButton text={t("accept")} theme="dark" onClick={onAccept} />
          </div>
        </div>
      </div>

      <CookieManageModal
        open={manageOpen}
        current={current}
        onSave={(prefs) => {
          setManageOpen(false);
          onSave(prefs);
        }}
        onAcceptAll={() => {
          setManageOpen(false);
          onAccept();
        }}
        onClose={() => setManageOpen(false)}
      />
    </>
  );
}
